import { Button } from '@finpay-development/shared-components';
import {
  Box,
  Typography,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface DeletePaymentMethodWarningModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeletePaymentMethodWarningModal({
  isOpen,
  onCancel,
  onConfirm,
}: DeletePaymentMethodWarningModalProps) {
  return (
    <Dialog
      open={isOpen}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      className="modal user-modal requirements-modal"
      test-id="delete-payment-method-warning-modal"
    >
      <DialogTitle className="spa-modal-title">
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
          <WarningAmberIcon sx={{ color: '#f5a623' }} />
          Payment Method In Use
        </Box>
      </DialogTitle>
      <DialogContent>
        <Grid container direction="column" style={{ padding: "1.5rem 0 2rem 0" }}>
          <Typography
            style={{
              fontSize: "16px",
              fontFamily: "Inter",
              lineHeight: "25px",
              fontWeight: "400",
              color: "#808080",
            }}
          >
            This payment method is tied to an active payment program. Removing it without adding a replacement before the next billing date will disrupt scheduled payments.
          </Typography>
        </Grid>
      </DialogContent>
      <DialogActions style={{ padding: "2rem" }}>
        <Button
          type="secondary"
          onClick={onCancel}
          test-id="delete-warning-cancel-btn"
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          test-id="delete-warning-confirm-btn"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeletePaymentMethodWarningModal;
